/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { sliceDataByQuery } from '@gh/core-data';
import {
  AutocompleteLoadMoreEvent,
  DialogInput,
  EmptyDialogInput,
  NotificationService,
  WaitingService,
} from '@gh/core-ui';
import { includesIgnoreCase } from '@gh/core-util';
import { PreConstructionWorksheetInit } from '../../../resources/pre-construction-worksheet.model';
import { ScheduleTemplateListItem } from '../../../resources/schedule-list.model';
import { WorksheetTemplateDialogBusinessService } from '../../../resources/worksheet-template-dialog-business.service';

@Component({
  selector: 'gh-worksheet-template-dialog',
  template: require('./worksheet-template-dialog.component.html'),
  styles: [require('./worksheet-template-dialog.component.scss')],
})
export class WorksheetTemplateDialogComponent implements OnInit, DialogInput<EmptyDialogInput> {
  input: EmptyDialogInput;

  form: FormState<PreConstructionWorksheetInit>;

  templates: ScheduleTemplateListItem[];

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              private waitings: WaitingService,
              private notifications: NotificationService,
              private business: WorksheetTemplateDialogBusinessService) {
  }

  ngOnInit(): void {
    const { templates } = getDialogInitData(this.dialogData);

    this.templates = templates;

    this.form = this.formStateBuilder.buildPlain({
      children: {
        nominatedTemplate: { required: true },
      },
    });
  }

  loadTemplates({ query, load }: AutocompleteLoadMoreEvent): void {
    load(sliceDataByQuery(this.templates.filter((template) => includesIgnoreCase(template.name, query.filter)), query));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { nominatedTemplate } = this.form.submitValue;
    this.business.setDefaultTemplate(nominatedTemplate).pipe(
      this.waitings.operator())
      .subscribe(
        () => this.dialogRef.close(nominatedTemplate.id),
        this.notifications.processAll);
  }
}

export const worksheetTemplateDialogRoute = createDialogRoute({
  component: WorksheetTemplateDialogComponent,
  init: WorksheetTemplateDialogBusinessService,
});
